export const getUnique = (arr, getHash) => {
    const set = {}
    getHash = getHash || (e => '' + e)
    arr.forEach(e => {
        const key = getHash(e)
        set[key] = set[key] || e
    });
    return Object.values(set)
}